var module;
// LICENSE_CODE ZON ISC
'use strict'; /*jslint node:true, browser:true*/
(function () {
  var is_node = typeof module == 'object' && module.exports && module.children;
  if (!is_node) ;else ;
  define(['/util/user_agent.js'], function (user_agent) {
    var E = {};
    var b_name = function b_name(s) {
      return /Chrome/.test(s) ? 'chrome' : /Safari/.test(s) ? 'safari' : /Opera/.test(s) ? 'opera' : /Edge/.test(s) ? 'edge' : s;
    };
    var get_browser = function get_browser(hints, ua) {
      var m;
      if (hints && hints.ua) {
        m = hints.ua.match(/"(.*?Safari.*?|.*?Chrome.*?|.*?Edge.*?|.*?Opera.*?)";\s?v="(.+?)"/);
        if (m) {
          return {
            name: b_name(m[1]),
            version: m[2]
          };
        }
      }
      if (hints && hints.brands) {
        m = hints.brands.find(function (br) {
          return /(Safari|Chrome|Edge|Opera)/.test(br.brand);
        });
        if (m) {
          return {
            name: b_name(m.brand),
            version: m.version
          };
        }
      }
      var b = user_agent.guess_browser(ua);
      if (b.edge) b.browser = 'edge';
      if (b.opera) b.browser = 'opera';
      return {
        name: b.browser,
        version: b.version
      };
    };
    var get_platform = function get_platform(hints, ua) {
      if (!hints || !hints.platform || !hints.platform_version) {
        var sys = user_agent.guess(ua);
        return {
          os: sys.os,
          version: sys.version,
          mobile: sys.mobile
        };
      }
      var p = hints.platform.match(/"(.+)"/);
      var v = hints.platform_version.match(/"(.+)"/);
      var os = (p && p[1] || hints.platform).toLowerCase();
      var version = v && v[1] || hints.platform_version;
      if (os == 'windows') {
        var v_int = parseInt(version);
        version = v_int == 0 ? '7' : v_int < 13 ? '10.0' : '11.0';
      }
      if (os == 'macos') version = version.replace(/_/g, '.');
      var mobile = hints.mobile == '?1' || hints.mobile == true;
      return {
        os: os,
        version: version,
        mobile: mobile
      };
    };
    E.get_client_hints = function (opt) {
      var hints = opt.hints || opt.req && {
        ua: opt.req.headers['sec-ch-ua'],
        platform: opt.req.headers['sec-ch-ua-platform'],
        platform_version: opt.req.headers['sec-ch-ua-platform-version'],
        mobile: opt.req.headers['sec-ch-ua-mobile']
      };
      var ua = opt.ua || opt.req && opt.req.headers['user-agent'];
      return {
        browser: get_browser(hints, ua),
        platform: get_platform(hints, ua)
      };
    };
    return E;
  });
})();